import React from 'react'
import styled from 'styled-components';
import { PRIMARY } from '../const/colors';

const Input = styled.input`
  appearance: none;
  background-color: transparent;
  margin: 0;
  font: inherit;
  color: ${PRIMARY};
  width: 1.15em;
  height: 1.15em;
  border: 1px solid ${PRIMARY};
  display: grid;
  place-content: center;

  ::before {
    content: "L";
    width: 0.6em;
    height: 0.8em;
    margin-bottom: 0.35rem;
    margin-left: 0.15rem;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
  }

  :checked::before {
    transform: scaleX(-1) rotate(-35deg);
  }
  
  @media screen and (max-width: 768px) {
    width: 1.95em;
    height: 1.95em;
  }
  
`;

const CustomCheckbox = (props) => {
  return (
    <Input {...props} />
  )
}

export default CustomCheckbox